import baseApi from ".";
import createQueryFn from "../createQueryFn";
import api from "api";
import { GetBookingsRequest, GetBookingsResponse } from "api/bookings/getBookings";

const bookingsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getBookings: builder.query<GetBookingsResponse, GetBookingsRequest | void>({
      queryFn: createQueryFn(api.bookings.getBookings),
      providesTags: [{ type: "Booking", id: "LIST" }],
    }),
  }),
});

export const {
  useGetBookingsQuery,
} = bookingsApi;

export default bookingsApi;
